import store from '@/store';

const setBreadcrumbs = crumbs => {
    store.dispatch(`app/setBreadcrumbs`, crumbs);
};

export default setBreadcrumbs;
